import axios from '../../../helpers/custom-axios';
import { confirmation, notify } from '../../../helpers/notifications';

export const createContainerRole = async (role) => {
  return axios
    .post(`/manage/roles`, { role })
    .then((res) => {
      notify.success('Role Created');
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    });
};

export const updateContainerRole = async (id, role) => {
  return axios
    .put(`/manage/roles/${id}`, { role })
    .then((res) => {
      notify.saved();
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    });
};

export const destroyContainerRole = async (id) => {
  return axios
    .delete(`/manage/roles/${id}`)
    .then((res) => {
      notify.success();
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    });
};

export const destroyAllUserRoles = async (id, model, callback) => {
  confirmation.destroy(async () => {
    return axios
      .delete(`/manage/roles/remove_all`, { params: { id, model } })
      .then((res) => {
        notify.alertSuccess('All Permissions Removed');
        callback(res);
      })
      .catch((error) => {
        notify.failure();
        callback(error);
      });
  });
};
